/**
 * The maximum safe 32-bit signed integer value (2^31 - 1).
 * This is the largest value that can be stored in an Int32Array or similar typed array.
 * Useful for boundary checking in integer operations.
 */
export const INT32_MAX_VALUE = 2147483647;
/**
 * The minimum safe 32-bit signed integer value (-2^31).
 * This is the smallest value that can be stored in an Int32Array or similar typed array.
 * Useful for boundary checking in integer operations.
 */
export const INT32_MIN_VALUE = -2147483648;
//# sourceMappingURL=limits.js.map